import { useState, useEffect } from 'react'

export function useGeolocation(enabled = true) {
  const [location, setLocation] = useState({ lat: 51.5074, lon: -0.1278, loading: enabled, error: null })

  useEffect(() => {
    if (!enabled) return
    if (!navigator.geolocation) {
      setLocation(prev => ({ ...prev, loading: false, error: 'Geolocation not supported' }))
      return
    }
    
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        setLocation({
          lat: pos.coords.latitude,
          lon: pos.coords.longitude,
          loading: false,
          error: null,
        })
      },
      (err) => {
        setLocation(prev => ({ ...prev, loading: false, error: err.message }))
      },
      { enableHighAccuracy: true, timeout: 10000 }
    )
  }, [enabled])
  
  return location
}
